import { render, staticRenderFns } from "./MonthlyTabulation.vue?vue&type=template&id=1ffb99ad&scoped=true"
import script from "./MonthlyTabulation.vue?vue&type=script&lang=ts"
export * from "./MonthlyTabulation.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyTabulation.vue?vue&type=style&index=0&id=1ffb99ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb99ad",
  null
  
)

export default component.exports